import { getQueryString, setQueryString } from "./urlUtils";

const enableBillingRunningTotal = process.env.REACT_APP_FEATURE_BILLED_RUNNING_TOTAL === '1' || localStorage.getItem('REACT_APP_FEATURE_BILLED_RUNNING_TOTAL') === '1';
const enable5ZipWarning = process.env.REACT_APP_FEATURE_5_ZIP_WARNING === '1' || localStorage.getItem('REACT_APP_FEATURE_5_ZIP_WARNING') === '1';
const enableESRDNdc = process.env.REACT_APP_FEATURE_ESRD_NDC === '1' || localStorage.getItem('REACT_APP_FEATURE_ESRD_NDC') === '1';
const enableUpDownLineNavigation = process.env.REACT_APP_FEATURE_UP_DOWN_LINE_NAVIGATION === '1' || localStorage.getItem('REACT_APP_FEATURE_UP_DOWN_LINE_NAVIGATION') === '1';
const enableOceEnhancements = process.env.REACT_APP_FEATURE_DISPLAY_OCE_ENHANCEMENTS === '1' || localStorage.getItem('REACT_APP_FEATURE_DISPLAY_OCE_ENHANCEMENTS') === '1';
const enableAsyncPricingApi = process.env.REACT_APP_FEATURE_ASYNC_PRICING_API === '1' || localStorage.getItem('REACT_APP_FEATURE_ASYNC_PRICING_API') === '1';
const enableDashboard = true; //process.env.REACT_APP_FEATURE_ENABLE_BATCH_DASHBOARD === '1' || localStorage.getItem('REACT_APP_FEATURE_ENABLE_BATCH_DASHBOARD') === '1';
const enableDeletion = process.env.REACT_APP_FEATURE_ENABLE_BATCH_DELETION === '1' || localStorage.getItem('REACT_APP_FEATURE_ENABLE_BATCH_DELETION') === '1';
const enableBatchRowLimit = process.env.REACT_APP_FEATURE_ENABLE_BATCH_UPLOAD_LIMIT === '1' || localStorage.getItem('REACT_APP_FEATURE_ENABLE_BATCH_UPLOAD_LIMIT') === '1';
const enableMoreInfoButton = process.env.REACT_APP_FEATURE_ENABLE_MORE_INFO_BUTTON === '1' || localStorage.getItem('REACT_APP_FEATURE_ENABLE_MORE_INFO_BUTTON') === '1';


const enableorDisableFeaturesFromUrl = () => {
    const queryStrings = getQueryString();
    const keys = Object.keys(queryStrings);
    const featureKeys = keys.filter(k => k.indexOf('REACT_APP_FEATURE_') === 0);

    for (const k of featureKeys) {
        localStorage.setItem(k, queryStrings[k]);
    }

    if (featureKeys.length > 0) {
        const newQueryString = {}; 
        for(const k of keys.filter(ke => !featureKeys.includes(ke))) {
            newQueryString[k] = queryStrings[k];
        }

        setQueryString(newQueryString);
    }
}

export {
    enableBillingRunningTotal,
    enable5ZipWarning,
    enableESRDNdc,
    enableUpDownLineNavigation,
    enableOceEnhancements,
    enableAsyncPricingApi,
    enableDashboard,
    enableDeletion,
    enableBatchRowLimit,
    enableMoreInfoButton,
    enableorDisableFeaturesFromUrl
};